import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ServicesComponent } from './component/services.component';



const routes: Routes = [
  {
    path: '',
    title: 'services',
    component: ServicesComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class ServicesRoutingModule { }
